import { render, staticRenderFns } from "./DefaultLanguageSettings.vue?vue&type=template&id=bbf3084a&scoped=true&"
import script from "./DefaultLanguageSettings.vue?vue&type=script&lang=js&"
export * from "./DefaultLanguageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf3084a",
  null
  
)

export default component.exports